module.exports = __webpack_public_path__ + "static/media/SDFSA_3-384w.682dad81.webp";